// src/modals/TileDetailsModal.js

import React from 'react';
import Modal from 'react-modal';
import './css/TileDetailsModal.css';
import tileInformation from '../../utils/tileInformation.json';
import HasPermission from '../../utils/HasPermission';
import { getBaseTileType } from '../../utils/tileEntityOptions';

const CONFIRMABLE_LOCATION_TYPES = new Set(['city', 'flag', 'allianceHall', 'fort']);

const TileDetailsModal = ({
  isOpen,
  onRequestClose,
  selectedTile,
  onDeleteTile,
  onDeleteAllianceTerritory,
  canWriteTiles = false,
  onToggleConfirmedLocation = null
}) => {
  if (!isOpen || !selectedTile) return null;
  const modalStyle = {
    content: {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '90%', // Adjust for smaller screens
      maxWidth: '400px', // Limit max width for larger screens
      height: 'auto',
      maxHeight: '80vh', // Prevent content overflow
      overflowY: 'auto', // Add vertical scrolling if needed
      padding: '20px',
      borderRadius: '10px',
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
  };
  
  const { x } = selectedTile;
  const { y } = selectedTile;
  const { type } = selectedTile;
  const baseType = getBaseTileType(type);
  let alliance, level, commander, displayType;
  const allianceId = selectedTile.additionalTileInfo?.alliance?._id;
  const canDeleteAllianceTerritory = ['flag', 'fort', 'allianceHall'].includes(type);
  const canConfirmLocation = canWriteTiles
    && CONFIRMABLE_LOCATION_TYPES.has(baseType)
    && typeof onToggleConfirmedLocation === 'function';
  const isConfirmed = Boolean(selectedTile?.confirmed);

  if (selectedTile.additionalTileInfo != null) {
    if (selectedTile.type === "benefit" || selectedTile.type === "eliteMine") {
      alliance = selectedTile.additionalTileInfo.alliance?.acronym
        ? selectedTile.additionalTileInfo.alliance.acronym
        : "unclaimed / unkown (select determine ownership)";
    } else if (selectedTile.type === "city") {
      alliance = selectedTile.additionalTileInfo.commander?.alliance?.acronym ? selectedTile.additionalTileInfo.commander?.alliance?.acronym : `N/A`
      commander = selectedTile.additionalTileInfo.commander ? selectedTile.additionalTileInfo.commander : {};
    } else {
      alliance = selectedTile.additionalTileInfo.alliance?.acronym
      level = selectedTile.additionalTileInfo.level;
    }
  }

  if (type === "benefit") {
    displayType = tileInformation[type].niceName + " - " + tileInformation[type].subTypes[selectedTile.additionalTileInfo.benefitSubType]
  } else {
    displayType = tileInformation[type].niceName
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Tile Details"
      className="tile-details-modal"
      overlayClassName="tile-details-modal-overlay"
      style={modalStyle}
    >
      <h2>{displayType}</h2>
      <h3>Location: {x}, {y} </h3>
      <div>
        {commander && <p>Commander: {commander.name ? commander.name : `DELETED / UNKOWN`}</p>}
        {alliance && <p>Alliance: {alliance}</p>}
        {level && <p>Level: {level}</p>}
        {commander?.battlePower && <p>Battle Power: {commander.battlePower.toLocaleString()}</p>}
      </div>
      {HasPermission("deleteTiles") && (
        <button onClick={onDeleteTile}>Delete Tile</button>
      )}
      {canConfirmLocation && (
        <button onClick={onToggleConfirmedLocation}>
          {isConfirmed ? 'Unconfirm Location' : 'Confirm Location'}
        </button>
      )}
      {HasPermission("deleteTiles") && canDeleteAllianceTerritory && allianceId && onDeleteAllianceTerritory && (
        <button onClick={() => onDeleteAllianceTerritory(selectedTile)}>
          Delete Alliance Territory
        </button>
      )}

      <button onClick={onRequestClose}>Close</button>
    </Modal>
  );
};

export default TileDetailsModal;
